<template>
    <div class="book-keeping-container">
        <Layout type="BK" name="代理记账服务">
            <product-buy slot="buy" :baseInfo="baseInfo" type="bookkeeping" @buy="onBuy" @ask="onAsk">
            <div class="form-data-container" slot="form">
                <div class="form-item">
                <div class="form-label">注册类型：</div>
                <div class="form-content">
                    <div
                    :class="['select-item', item.value === typeSelected ? 'be-selected' : '']"
                    v-for="(item, index) in typeDatasource" :key="index"
                    @click="onSelect('type', item)">
                    <div>{{item.text}}</div>
                    <img class="selected-img" v-if="item.value === typeSelected" src="../assets/selected.png">
                    </div>
                </div>
                </div>
                <div class="form-item" v-if="typeSelected !== 'zero'">
                <div class="form-label">年开票额：</div>
                <div class="form-content">
                    <div
                    :class="['select-item', item.value === moneySelected ? 'be-selected' : '']"
                    v-for="(item, index) in moneyDatasource" :key="index"
                    @click="onSelect('money', item)">
                    <div>{{item.text}}</div>
                    <img class="selected-img" v-if="item.value === moneySelected" src="../assets/selected.png">
                    </div>
                </div>
                </div>
                <div class="form-item">
                <div class="form-label">服务时长：</div>
                <div class="form-content">
                    <div
                    :class="['select-item', item.value === yearSelected ? 'be-selected' : '']"
                    v-for="(item, index) in yearDatasource" :key="index">
                    <div>{{item.text}}</div>
                    <img class="selected-img" v-if="item.value === yearSelected" src="../assets/selected.png">
                    </div>
                </div>
                </div>
            </div>
            </product-buy>
            <product-intro slot="intro" type="BK">
            <div class="product-info-content book-keeping-content" slot="content">
                <div class="info-item-content book-title-content">
                <h2 class="book-intro-title">服务介绍</h2>
                <p class="book-intro-des">企业支付不到一个人的成本，就可以享受到全国专业的服务；服务标准、定价公开透明、信息安全保密、服务进度透明、实时在线可查；覆盖全国主要区域，满足不同类型的企业需求，帮您轻松完成企业财务税务管理</p>
                <div class="book-intro">
                    <div class="book-intro-item" v-for="(item, index) in intro" :key="index">
                    <img :src="item.icon">
                    <p>{{item.text}}</p>
                    </div>
                </div>
                </div>
                    <div class="info-item-content book-title-content">
                        <h2 class="content-title">服务内容</h2>
                        <div class="book-content">
                            <div class="book-content-left">
                                <div
                                    v-for="(item, index) in serviceContent"
                                    :key="index"
                                    class="book-content-item"
                                >
                                    <div class="bk-icon"></div>
                                    <div class="bk-text">{{ item }}</div>
                                </div>
                            </div>
                            <div class="book-content-img"></div>
                        </div>
                    </div>
                <div class="info-item-content advantage-content">
                <h2 class="advantage-title">服务优势</h2>
                <div class="book-advantage">
                    <div class="book-advantage-item" v-for="(item, index) in advantage" :key="index">
                    <img :src="item.icon">
                    <div class="book-advantage-text">
                        <h4>{{item.title}}</h4>
                        <p>{{item.des}}</p>
                    </div>
                    </div>
                </div>
                </div>
                <div class="info-item-content process-content">
                <h2 class="process-title">办理流程</h2>
                <img class="process-icon" src="../assets/book_liucheng.png">
                </div>
                <div class="info-item-content materials-content">
                <h2 class="materials-title">办理材料</h2>
                <div class="book-materials">
                    <div class="book-advantage-item" v-for="(item, index) in materials" :key="index">
                    <img :src="item.icon">
                    <h4>{{item.title}}</h4>
                    <div class="materials-text">
                        <p v-for="(desItem, index) in item.des" :key="index">{{desItem}}</p>
                    </div>
                    </div>
                </div>
                </div>
                <div class="info-item-content problem-content">
                <h2 class="problem-title">常见问题</h2>
                <img class="problem-icon" src="../assets/problem_icon.png">
                <div class="problem-item-content">
                    <div class="problem-item" v-for="(item, index) in problem" :key="index">
                    <h4>{{item.title}}</h4>
                    <p>{{item.des}}</p>
                    </div>
                </div>
                </div>
            </div>
            </product-intro>
        </Layout>
    </div>
</template>

<script>
import Layout from '../components/Layout.vue';
import ProductBuy from '../components/ProductBuy.vue';
import ProductIntro from '../components/ProductIntro.vue';
import bookZhuanye from '../assets/book_zhuanye.png';
import bookDijia from '../assets/book_dijia.png';
import bookAnquan from '../assets/book_anquan.png';
import bookShouhou from '../assets/book_shouhou.png';
import bookOcr from '../assets/book_ocr.png';
import bookShishi from '../assets/book_shishi.png';
import bookZhineng from '../assets/book_zhineng.png';
import bookShuiwu from '../assets/book_shuiwu.png';
import bookShouci from '../assets/book_shouci.png';
import bookRichang from '../assets/book_richang.png';
import bookQiehu from '../assets/book_qiehu.png';
import keepIcon from '../assets/book_icon2.png';
import dacu from '../assets/dacu.png';

import DATA from '../common/data.js';

export default {
    components: {
        Layout,
        ProductBuy,
        ProductIntro
    },
    metaInfo: {
        title: '代理记账服务_代理做账报税服务——百度智能云企业服务中心',
        meta: [
            {
                name: 'keywords',
                content: '代理记账,代账公司,记账报税,财税代理,全国代理记账',
            },
            {
                name: 'description',
                content: '百度智能云企业服务代理记账服务，资深团队多对一服务，做账准确，线上随时查账，服务范围支持全国',
            }
        ]
    },
    data () {
        return {
            baseInfo: {
                icon: keepIcon,
                title: '代理记账服务',
                des: '云会计代理记账，品质服务，安心代账',
                price: '1199元',
                unit: '/次',
                priceIcon: dacu,
                originPrice: '1499元/次',
                advantage: [
                '实时响应，专家服务',
                '一次性收费，无隐形费用',
                '服务流程全监管'
                ],
                serviceAdvantage: [
                '经营性网站必备资质',
                '助企业合法合规经营',
                '新品上架，限时优惠'
                ]
            },
            typeDatasource: [
                {
                text: '零申报',
                value: 'zero'
                },
                {
                text: '小规模',
                value: 'small'
                },
                {
                text: '一般纳税人',
                value: 'normal'
                }
            ],
            typeSelected: 'zero',
            smallMoneyDatasource: [
                {
                    text: '0-120万元',
                    value: 'small'
                },
                {
                    text: '120-300万元',
                    value: 'normal'
                },
                {
                    text: '300-700万元',
                    value: 'large'
                }
            ],
            moneySelected: 'small',
            normalMoneyDatasource: [
                {
                    text: '0-300万元',
                    value: 'small'
                },
                {
                    text: '300-700万元',
                    value: 'normal'
                },
                {
                    text: '700-2000万元',
                    value: 'large'
                }
            ],
            yearDatasource: [
                {
                text: '1年',
                value: 1
                }
            ],
            yearSelected: 1,
            selectItem: DATA.productData[0],
            intro: [
                {
                text: '专业咨询',
                icon: bookZhuanye
                },
                {
                text: '低价透明',
                icon: bookDijia
                },
                {
                text: '安全保密',
                icon: bookAnquan
                },
                {
                text: '售后无忧',
                icon: bookShouhou
                }
            ],
            advantage: [
                {
                icon: bookOcr,
                title: 'OCR票据识别',
                des: '运用OCR图像扫描技术，帮助会计快速识别票据并查验核实真伪，提高做账效率'
                },
                {
                icon: bookShishi,
                title: '实时查账',
                des: '在线查看企业账务情况，服务进度实时可查，一目了然'
                },
                {
                icon: bookZhineng,
                title: '智能生成凭证',
                des: '将发票或单据自动匹配会计科目，根据不同经济活动将票据分类，自动生成对应凭证'
                },
                {
                icon: bookShuiwu,
                title: '税务风险预警',
                des: '对帐数据发现风险第一时间预警，并提供相关财税建议'
                }
            ],
            materials: [
                {
                title: '首次做账所需材料',
                des: ['营业执照', '税号及报税密码'],
                icon: bookShouci
                },
                {
                title: '日常月度记账所需材料',
                des: ['发票清单', '银行对账单、回执单、工资单'],
                icon: bookRichang
                },
                {
                title: '切户所需材料',
                des: ['交接单/历史账簿/凭证/纳税申报表', '税号及报税密码，税控盘（可选）'],
                icon: bookQiehu
                }
            ],
            problem: [
                {
                    title: '什么是0申报？',
                    des: '0申报需要符合 1、无银行、支付宝、微信流水（账户管理费除外） 2、无票据（收入票、费用票）3、除法人外无社保、员工工资 4、无纳税额 '
                },
                {
                    title: '我获得的服务结果？',
                    des: '财务报表、记账凭证、纳税申报表、账本'
                },
                {
                title: '都有什么票据可以用来做账？',
                des: '发票、银行单据、工资表、现金借款收支单据等'
                },
                {
                title: '我可以不请会计，自己做账吗？',
                des: '不行的，《会计法》规定从事会计工作的人员都必须取得会计从业资格证，必须是会计才能做账'
                },
                {
                title: '新注册的公司没业务，是否可以不记账不报税？',
                des: '不可以，工商、税务已经于2015年6月1日与中国人民银行个人引用征信系统联网，公司未注销的情况下，必须做账报税，否则法人及股东将会有信用污点'
                },
                {
                title: '每月几号开始记账，几号报税？',
                des: '每月票收到就开始记账，1-15日报税，法定节假日按照税局要求调整'
                }
            ],
            serviceContent: [
                '建立账套',
                '整理原始凭证',
                '每月核对票据',
                '每月编制记账凭证',
                '编制资产负债表、利润表',
                '增值税、印花税、附加税、个人所得税、企业所得税等纳税申报',
                '每月装订记账凭证，总账、明细账、财税报表',
                '企业所得税年度汇算清缴申报',
                '工商年报（企业年检）'
            ],
        }
    },
    computed: {
        moneyDatasource() {
            if (this.typeSelected === 'normal') {
                return this.normalMoneyDatasource;
            }
            return this.smallMoneyDatasource;
        }
    },
    methods: {
        onSelect(type, item) {
            this[type + 'Selected'] = item.value;
            let find = {};
            for (let i = 0; i < DATA.productData.length; i++) {
                if (this.typeSelected === 'zero' && DATA.productData[i].type === 'zero'
                || (this.typeSelected === DATA.productData[i].type
                && this.moneySelected === DATA.productData[i].money)) {
                find = DATA.productData[i];
                break;
                }
            }
            Object.assign(this.baseInfo, {
                price: find.price,
                originPrice: find.originPrice
            });
            this.selectItem = find;
        },
        onBuy() {
            window.location.href = `https://console.bce.baidu.com/mkt/#/mkt/order/purchase~productId=f1135955-1d69-4d88-994c-dd0419fe419b&packageId=${this.selectItem.packageId}&periodId=${this.selectItem.periodId}&pageSource=aiqichaland&quantity=1`;
        },
        onAsk() {
            window.open('http://webui.im.bdymkt.com/pageinfo.jsp?version=vip&admiuin=9371462&ltype=1&iscallback=1&page_templete_id=44965&is_message_sms=0&is_send_mail=0&action=acd&acd=1&type_code=3');
        }
    }
}
</script>

<style lang="less">
.book-intro-title {
    background-image: url(../assets/book_title_bac.png);
}
.book-intro-des {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #191C3D;
    opacity: 0.6;
    margin: 10px auto 48px;
    text-align: center;
    width: 816px;
}
.book-intro {
    width: 608px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto 39px;
    .book-intro-item {
        width: 96px;
    }
    img {
        width: 96px;
        height: 96px;
        display: block;
    }
    p {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 22px;
        color: #191C3D;
        opacity: 0.8;
        height: 22px;
        text-align: center;
        margin-top: 16px;
    }
    }
    .process-content {
    .process-icon {
        display: block;
        width: 833px;
        height: 227px;
        margin: 20px auto 40px;
    }
}
.book-advantage {
    width: 814px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 20px auto 14px;
    .book-advantage-item {
        width: 391px;
        height: 109px;
        background: #FFFFFF;
        box-shadow: 0px 0px 10px rgba(13, 78, 255, 0.16);
        padding: 16px;
        margin-bottom: 30px;
        img {
        width: 40px;
        height: 40px;
        float: left;
        }
        .book-advantage-text {
        margin-left: 50px;
        h4 {
            height: 25px;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 25px;
            color: #191C3D;
        }
        p {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: #191C3D;
            opacity: 0.65;
        }
        }
    }
}
.book-materials {
    width: 815px;
    margin: 26px auto 50px;
    display: flex;
    justify-content: space-between;
    .book-advantage-item {
        position: relative;
        img {
        position: absolute;
        top: 0;
        left: 0;
        width: 260px;
        height: 58px;
        }
        h4 {
        width: 260px;
        height: 58px;
        padding-top: 17px;
        padding-left: 10px;
        position: relative;
        z-index: 10;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 25px;
        color: #FFFFFF;
        }
        .materials-text {
        height: 69px;
        border: 1px solid #D8D8D8;
        border-top: none;
        padding-top: 8px;
        padding-left: 23px;
        p {
            height: 20px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: #191C3D;
            opacity: 0.8;
            position: relative;
        }
        p:before {
            content: '';
            position: absolute;
            left: -10px;
            top: 6px;
            width: 6px;
            height: 6px;
            background: #FD6C41;
            display: block;
            border-radius: 50%;
        }
        }
    }
}

.book-content {
    display: flex;
    justify-content: space-between;
    padding: 27px 50px 33px;
    .book-content-item {
        display: flex;
        margin-bottom: 16px;
        align-items: flex-start;
    }
    .bk-text {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #1b1e3f;
        letter-spacing: 0;
        font-weight: 400;
        width: 320px;
    }
    .bk-icon {
        background: url('../assets/book_service_icon.png') no-repeat;
        width: 22px;
        height: 22px;
        background-size: cover;
        margin-right: 12px;
    }
    .book-content-img {
        width: 410px;
        height: 348px;
        background: url('../assets/book_service_content.png') no-repeat;
        background-size: cover;
    }
}
</style>
